import { useEffect } from 'react';

const useDepartureWatcher = ({ finished, tick, deadlineTs, onTimeUp }) => {
  useEffect(() => {
    if (finished || !deadlineTs) return;

    if (Date.now() >= deadlineTs) onTimeUp();
  }, [tick, finished, deadlineTs, onTimeUp]);
};

export default useDepartureWatcher;
